var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhiteout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 260,
    height: 47,
    viewBox: "0 0 260 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.8,
    d: "M0 0H129.6V45.9H0z"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000",
    fillRule: "nonzero",
    fontFamily: "Roboto-Bold, Roboto",
    fontSize: 19,
    fontWeight: "bold",
    letterSpacing: 2.85
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 141.019,
    y: 28
  }, "HEALTH")), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "square",
    strokeWidth: 1.8,
    d: "M253.5 46.548L253.5 0.452"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000",
    fillRule: "nonzero",
    fontFamily: "Roboto-Bold, Roboto",
    fontSize: 19,
    fontWeight: "bold",
    letterSpacing: 2.85
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 18.774,
    y: 30
  }, "MATTER"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhiteout);
export default __webpack_public_path__ + "static/media/logo-whiteout.cb442998.svg";
export { ForwardRef as ReactComponent };